import React, { useContext, useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import clsx from 'clsx';
import { Trailer, TrailerLocation } from '../../types';
import { CategoryContext } from '../../utils/context';

type Props = {
	spot: any;
	spotOrientation?: 'Top' | 'Bottom';
	lot: TrailerLocation;
	trailers: Trailer[];
	spotClicked: (spot: any) => void;
	trailerClicked: (trailer: Trailer) => void;
	addOpen: () => void;
	tempModal: () => void;
};

export default function LotSpot({
	spot,
	spotOrientation = 'Top',
	trailers,
	lot,
	spotClicked,
	addOpen,
	tempModal,
	trailerClicked,
}: Props) {
	const [categoriesOptions, setCategoriesOptions] = useState<
		{ categoryName: string; color: string }[]
	>([]);

	const categories = useContext(CategoryContext);

	useEffect(() => {
		const temp = categories.map((category: any) => {
			return { categoryName: category.categoryName, color: category.color };
		});

		setCategoriesOptions(temp.sort());
	}, [categories]);

	function getColor(trailer: Trailer) {
		const [category] = categoriesOptions.filter((c) => c.categoryName === trailer.category);
		return category !== undefined ? category.color : 'blue-100';
	}

	function getFontColor(trailer: Trailer) {
		const [category] = categoriesOptions.filter((c) => c.categoryName === trailer.category);
		// return category !== undefined ? category.color : 'blue-100';

		if (category) {
			const number = parseInt(category.color.split('-')[1]);

			return number >= 500 ? 'white' : 'black';
		}
	}

	function handleAddClick() {
		spotClicked(spot);
		addOpen();
	}

	function handleEditClick(trailer: Trailer) {
		tempModal();
		trailerClicked(trailer);
	}

	function classNames(...classes: any) {
		return classes.filter(Boolean).join(' ');
	}

	if (trailers)
	{
		if (
			trailers.find(
				(trailer) =>
					parseInt(trailer?.Spots?.name) === parseInt(spot?.name) && (trailer?.trailerLocation === lot),
			)
		) {
						
			const trailer = trailers.find(
				(trailer) =>
					parseInt(trailer?.Spots?.name) === parseInt(spot?.name) && (trailer?.trailerLocation === lot),
			);

			if (trailer !== undefined) {
				return (
					<div className="flex flex-col justify-center items-center">
						{spotOrientation === 'Top' ? (
							<div className={clsx(' text-2xs font-bold')}>{spot.name}</div>
						) : null}

						<div className="flex space-x-1 w-4 h-20 bg-white rounded-md justify-center text-center shadow-md border-gray-600 border-2" style={{height:'7rem'}}>
							<button
								data-tip={trailer.comments}
								data-for={trailer.id.toString()}
								data-tooltip-id={`tooltip-${trailer.id}`}
								className={classNames(
									'focus:outline-none w-full rounded flex justify-center items-center',
									`bg-${getColor(trailer)}`,
									`text-${getFontColor(trailer)}`,
								)}
								onClick={() => handleEditClick(trailer)}
							>
								<span className="upRight text-2xs font-bold" style={{fontSize:'12px'}}>{trailer?.trailerNumber}</span>
							</button>
						</div>
						<Tooltip
						id={`tooltip-${trailer.id}`}
						place="top"
						render={() => (
							<div className="flex flex-col justify-center w-full">
								<h1 className="border-b border-white w-full" style={{ fontSize: '15px' }}>
								{trailer.carrier}
								</h1>
								<h1 style={{ fontSize: '15px' }}>{trailer.comments}</h1>
							</div>
						)}
						border={'1px solid black'}
						style={{ backgroundColor: '#222', color: 'white' }}
						/>
					</div>
				);
			}
		}
	}

	return (
		<div className="flex flex-col justify-center items-center">
			{spotOrientation === 'Top' ? (
				<div className={clsx(' text-2xs font-bold')}>{spot.name}</div>
			) : null}
			<div className="flex w-4 h-20 bg-white rounded-md justify-center shadow-md border-gray-600 border-2"style={{height:'7rem'}}>
				<button
					className="text-black h-full w-full flex justify-center items-center focus:outline-none text-xs"
					onClick={handleAddClick}
				>
					<span style={{ textOrientation: 'upright', writingMode: 'vertical-rl' }}></span>
				</button>
			</div>
			{spotOrientation === 'Bottom' ? <div className="text-2xs font-bold">{spot.name}</div> : null}
		</div>
	);
}
